import { Home, LogOut, Moon, Sun } from "lucide-react";
import { Link, NavLink } from "react-router-dom";

import { useAuth } from "../lib/auth";
import { useTheme } from "../lib/theme";
import { LogoMark } from "./LogoMark";

export function AppShell({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="app-shell">
      <header className="app-topbar">
        <Link to="/app" className="brand-mark" aria-label="CosaFlow dashboard">
          <LogoMark />
          <span>CosaFlow</span>
        </Link>
        <nav className="topbar-actions" aria-label="Application">
          <NavLink to="/app" className="nav-button">
            <Home size={17} />
            Dashboard
          </NavLink>
          <button className="icon-button" type="button" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <span className="user-pill">{user?.full_name || user?.email}</span>
          <button className="icon-button" type="button" onClick={logout} aria-label="Log out">
            <LogOut size={18} />
          </button>
        </nav>
      </header>
      <main className="app-main">{children}</main>
    </div>
  );
}
